import moment from "moment";
import type { DSPFlight } from "../../../zodios/apiDefinitions/api/dsp/orderDatasets";

// Extracts the earliest start date and latest end date from an array of DSP flights.
export function getFlightDateRange(flights: DSPFlight[]): {
  startDate: string | undefined;
  endDate: string | undefined;
} {
  const starts = flights.map((f) => f.startDateTime && moment(f.startDateTime)).filter(Boolean);
  const ends = flights.map((f) => f.endDateTime && moment(f.endDateTime)).filter(Boolean);

  return {
    startDate: starts.length > 0 ? moment.min(starts).toISOString() : undefined,
    endDate: ends.length > 0 ? moment.max(ends).toISOString() : undefined,
  };
}
